// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--VtYQI","rate":"_02712f2b3b--rate--LknX1"};